import { AccredibleAccountsRedirectionService } from '@accredible-frontend-v2/services/accounts-redirection';
import { LerAuthenticationApiService } from '@ler/domain';
import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

export const lerAuthGuard: CanActivateFn = () => {
  const authApi = inject(LerAuthenticationApiService);
  const accountsRedirection = inject(AccredibleAccountsRedirectionService);
  const document = inject(DOCUMENT);

  if (authApi.getSessionToken()) {
    return true;
  }

  document.location.href = accountsRedirection.getLoginUrlOrigin('ler');
  return false;
};
